import { useHistory } from "react-router-dom";
export const useNavigation = () => {
  const history = useHistory();

  const navigateTo = (path, state = {}) => {
    history.push(path, state);
  };

  const goBack = () => {
    history.goBack();
  };

  return { history, navigateTo, goBack };
};
